// @flow
import React from "react";
import classnames from "classnames";
import { useTranslation } from "react-i18next";
import { Segment, Image, Header, Rating } from "semantic-ui-react";
import { HashLink } from "react-router-hash-link";

import { scrollToElement } from "Commons/Utilities/scrollTo";
import testimonials from "modules/LandingPage/misc/testimonials";

import type { OfferT } from "modules/Offers/misc/Types";
import type { ReminderT } from "modules/Reminder/misc/Types";

import { Button } from "shared/formElements";

import Styles from "./Testimonials.module.scss";

type Props = {
  offer: OfferT,
  reminder: ReminderT,
  category: string,
  fullWidth?: boolean,
};

const Testimonials = ({ offer, reminder, category, fullWidth }: Props) => {
  const { t } = useTranslation("offerPageDetail");
  const persons = testimonials.persons;

  return (
    <div className={Styles.testimonials}>
      <div className={classnames(Styles.responsiveContent, { [Styles.fullWidth]: fullWidth })}>
        <h4>{t("testimonials.title")}</h4>
        <div className={Styles.row}>
          {persons.map((person, i) => {
            if (i > 1 && i < 4)
              return (
                <Segment padded="very" key={i}>
                  <div className={Styles.testimonial}>
                    <Image floated="left" size="tiny" src={person.image} verticalAlign="middle" />
                    <Header as="h4">
                      {person.name}
                      <Header.Subheader>
                        <Rating disabled icon="star" color="green" defaultRating={5} maxRating={5} />
                      </Header.Subheader>
                    </Header>
                  </div>
                  <p>{person.text}</p>
                </Segment>
              );
          })}
        </div>
        <div className={Styles.row}>
          {persons.map((person, i) => {
            if (i > 3)
              return (
                <Segment padded="very" key={i}>
                  <div className={Styles.testimonial}>
                    <Image floated="left" size="tiny" src={person.image} verticalAlign="middle" />
                    <Header as="h4">
                      {person.name}
                      <Header.Subheader>
                        <Rating disabled icon="star" color="green" defaultRating={5} maxRating={5} />
                      </Header.Subheader>
                    </Header>
                  </div>
                  <p>{person.text}</p>
                </Segment>
              );
          })}
        </div>
        <HashLink to="#CSF" scroll={(el) => scrollToElement(el, "smooth", -80)}>
          <Button>{t("changeServiceCTA")}</Button>
        </HashLink>
      </div>
    </div>
  );
};

export default Testimonials;
